"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchMainBundleProduct = void 0;
var storefront_client_1 = require("../../../utils/storefront-client");
var fetchMainBundleProduct = function (shopifyProductHandle, storefrontAccessToken, shopifyDomain) {
    // TODO: use gql tag from graphql-tag
    var query = "\n    query {\n      product(handle: \"".concat(shopifyProductHandle, "\") {\n        subscriptionId: metafield(namespace: \"subscriptions\", key: \"subscription_id\") {\n          value\n        }\n        id\n        handle\n        variants(first: 10) {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n      }\n    }\n  ");
    return (0, storefront_client_1.queryGql)(query, { accessToken: storefrontAccessToken, apiVersion: '2022-10', shopifyDomain: shopifyDomain });
};
exports.fetchMainBundleProduct = fetchMainBundleProduct;
